import { MODAL } from '@/common/constants';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IModalState {
    isModalOpen: Record<MODAL, boolean>;
}

const initialState: IModalState = {
    isModalOpen: Object.values(MODAL).reduce((acc, modal) => {
        acc[modal] = false;
        return acc;
    }, {} as Record<MODAL, boolean>),
};

const modalSlice = createSlice({
    name: 'modal',
    initialState,
    reducers: {
        openModal: (state: IModalState, action: PayloadAction<MODAL>) => {
            state.isModalOpen[action.payload] = true;
        },
        closeModal: (state: IModalState, action: PayloadAction<MODAL>) => {
            state.isModalOpen[action.payload] = false;
        },
        clearModal: (state: IModalState) => {
            Object.keys(state.isModalOpen).forEach((key) => {
                state.isModalOpen[key as MODAL] = false;
            });
        },
    },
});

export const { openModal, closeModal, clearModal } = modalSlice.actions;

export default modalSlice.reducer;
